import { ENRICH_ONLY_ENV_PREFIX, extractCustomerName } from '@/utils/common';
function isEnrichOnlyEnv(hostname = window.location.hostname) {
    return hostname.startsWith(ENRICH_ONLY_ENV_PREFIX);
}
const hasEnrichAccessOnly = isEnrichOnlyEnv() || extractCustomerName(window.location.hostname) === 'enrich';
export { ENRICH_ONLY_ENV_PREFIX, isEnrichOnlyEnv, hasEnrichAccessOnly };
